import { internationalData } from "shared/config/airports/frequentPlaces/international";
import { nationalData } from "shared/config/airports/frequentPlaces/national";
import { nationalOriginsData } from "shared/config/airports/frequentPlaces/nationalOrigins";
import { topInternationalDestinationsData } from "shared/config/airports/frequentPlaces/top/internationalDestinations";
import { topNationalDestinationsData } from "shared/config/airports/frequentPlaces/top/nationalDestinations";
import { topNationalOriginsData } from "shared/config/airports/frequentPlaces/top/nationalOrigins";
import allAirportsData from "shared/config/airports/AllAirports/airports.json";

import { Airport } from "shared/types/airportsTypes";

export const getAirports = (): {
  origins: Airport[];
  nationalDestinations: Airport[];
  internationalDestinations: Airport[];
  findAirportByCode: (code: string) => Airport | null;
} => {
  const origins = [
    ...topNationalOriginsData.map((item) => ({ ...item, destak: true })),
    ...nationalOriginsData.filter(
      (item) =>
        !topNationalOriginsData.some((topItem) => topItem.code === item.code),
    ),
  ];

  const nationalDestinations = [
    ...topNationalDestinationsData.map((item) => ({ ...item, destak: true })),
    ...nationalData.filter(
      (item) =>
        !topNationalDestinationsData.some(
          (topItem) => topItem.code === item.code,
        ),
    ),
  ];

  const internationalDestinations = [
    ...topInternationalDestinationsData.map((item) => ({
      ...item,
      destak: true,
    })),
    ...internationalData.filter(
      (item) =>
        !topInternationalDestinationsData.some(
          (topItem) => topItem.code === item.code,
        ),
    ),
  ];

  const findAirportByCode = (code: string): Airport | null => {
    const found =
      origins.find((airport) => airport.code === code) ||
      nationalDestinations.find((airport) => airport.code === code) ||
      internationalDestinations.find((airport) => airport.code === code);

    if (found) return found;

    const jsonAirport = allAirportsData.find(
      (airport) => airport.airport_code === code,
    );

    if (!jsonAirport) return null;

    // Converte para tipo Airport
    const converted: Airport = {
      code: jsonAirport.airport_code,
      name: jsonAirport.airport_name,
      description: `${jsonAirport.city_name} - ${jsonAirport.airport_name} (${jsonAirport.airport_code}), ${jsonAirport.country_name}`,
      city: jsonAirport.city_name,
      countryCode: jsonAirport.country_code,
    };

    return converted;
  };

  return {
    origins,
    nationalDestinations,
    internationalDestinations,
    findAirportByCode,
  };
};
